"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _kx = require("@/api/kx");
var _systemConfig = require("@/api/systemConfig");
var _settingMer = _interopRequireDefault(require("@/utils/settingMer"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'KxConfig',
  data: function data() {
    return {
      loading: false,
      uploadAction: "".concat(_settingMer.default.apiBaseURL, "admin/upload/image"),
      cdnUrl: '',
      // CDN域名，用于拼接图片URL
      qrCodeFullUrl: '',
      // 收款码完整URL（用于上传后立即回显）
      configForm: {
        kx_happy_fruit_multiple: 10,
        kx_happy_fruit_multiple_enterprise: 10,
        kx_happy_fruit_multiple_merchant: 10,
        kx_commission_ratio: 50,
        kx_balance_ratio: 50,
        kx_extract_fee_rate: 30,
        kx_min_extract_amount: 100,
        kx_agent_min_direct: 5,
        kx_agent_min_team_consume: 1000,
        kx_qr_code_image: '',
        kx_default_invite_code: '',
        kx_platform_phone: ''
      }
    };
  },
  mounted: function mounted() {
    this.loadCdnUrl();
    this.loadConfig();
  },
  methods: {
    loadCdnUrl: function loadCdnUrl() {
      var _this = this;
      // 获取CDN域名，用于拼接图片URL
      (0, _systemConfig.mediaDomainApi)().then(function (res) {
        if (res && res.data) {
          _this.cdnUrl = res.data;
        }
      }).catch(function () {
        console.error('获取CDN域名失败');
      });
    },
    loadConfig: function loadConfig() {
      var _this2 = this;
      this.loading = true;
      (0, _kx.kxConfigListApi)().then(function (res) {
        if (res && Array.isArray(res)) {
          res.forEach(function (item) {
            if (_this2.configForm.hasOwnProperty(item.configKey)) {
              var numKeys = ['kx_happy_fruit_multiple', 'kx_happy_fruit_multiple_enterprise', 'kx_happy_fruit_multiple_merchant', 'kx_commission_ratio', 'kx_balance_ratio', 'kx_extract_fee_rate', 'kx_agent_min_direct'];
              if (numKeys.includes(item.configKey)) {
                _this2.configForm[item.configKey] = Number(item.value);
              } else if (item.configKey === 'kx_min_extract_amount' || item.configKey === 'kx_agent_min_team_consume') {
                _this2.configForm[item.configKey] = parseFloat(item.value);
              } else if (item.configKey === 'kx_qr_code_image') {
                // URL字段：去掉前导斜杠，与uploadPicture的sattDir格式保持一致
                var url = item.value || '';
                if (url.startsWith('/')) {
                  url = url.substring(1);
                }
                _this2.configForm[item.configKey] = url;
                // 清空上传后的缓存，因为现在是从DB加载的数据
                _this2.qrCodeFullUrl = '';
              } else {
                _this2.configForm[item.configKey] = item.value;
              }
            }
          });
        }
        _this2.loading = false;
      }).catch(function () {
        _this2.loading = false;
      });
    },
    handleQrCodeSuccess: function handleQrCodeSuccess(res) {
      if (res && res.data) {
        var url = res.data.url || res.data;
        console.log('上传接口返回:', url);
        // 上传接口返回完整URL（已通过ResponseRouter添加CDN前缀）
        // 提取相对路径用于保存，同时缓存完整URL用于立即回显
        var relativePath = url;
        if (url.startsWith('http://') || url.startsWith('https://')) {
          // 提取相对路径（去掉协议和域名）
          var match = url.match(/^https?:\/\/[^/]+\/(.+)$/);
          if (match) {
            relativePath = match[1];
          }
        } else if (url.startsWith('/')) {
          relativePath = url.substring(1); // 去掉前导斜杠
        }
        // 保存到表单（用于提交到后端）
        this.configForm.kx_qr_code_image = relativePath;
        // 缓存完整URL（用于立即回显）
        this.qrCodeFullUrl = url;
        this.$message.success('收款码上传成功');
      }
    },
    getImageUrl: function getImageUrl(path) {
      // 优先使用上传后缓存的完整URL（解决上传后立即回显的问题）
      if (this.qrCodeFullUrl && path === this.configForm.kx_qr_code_image) {
        return this.qrCodeFullUrl;
      }
      // 手动拼接CDN域名前缀
      if (!path) return '';
      if (path.startsWith('http://') || path.startsWith('https://')) {
        return path; // 已经是完整URL，直接返回（兼容DB存储完整URL的情况）
      }
      // 拼接CDN域名前缀（用于从DB读取的相对路径）
      return this.cdnUrl ? "".concat(this.cdnUrl, "/").concat(path) : path;
    },
    handleImageError: function handleImageError(err) {
      console.error('图片加载失败:', err);
      console.error('当前URL:', this.configForm.kx_qr_code_image);
      this.$message.error('图片加载失败，请检查URL是否正确或重新上传');
    },
    handleSave: function handleSave() {
      var _this3 = this;
      var total = this.configForm.kx_commission_ratio + this.configForm.kx_balance_ratio;
      if (total !== 100) {
        this.$message.warning("\u4F63\u91D1\u6BD4\u4F8B(".concat(this.configForm.kx_commission_ratio, "%) + \u4F59\u989D\u6BD4\u4F8B(").concat(this.configForm.kx_balance_ratio, "%) = ").concat(total, "%\uFF0C\u5E94\u4E3A100%"));
        return;
      }
      (0, _kx.kxConfigSaveApi)(this.configForm).then(function () {
        _this3.$message.success('配置保存成功');
      });
    }
  }
};